import { createSlice } from '@reduxjs/toolkit';
import apiClient from '../Api/api_client';
import { loadingSlice } from './LoadingStore';

export const defaultEntryState = {
    entries: [],
    error: '',
    page: 0,
    last_entry: null,
    promotionId: 0,
    grandPrizePoints: 0,
    currentPoints: 0,
    totalRecords: 0,
};

// REDUCERS
// basic actions that affect this object only

const getEntriesReducer = (state, action) => {
    if (action.payload.entries !== undefined) {
        // requested entries are already in the state no need to do update
        if (state.promotionId == action.payload.promotionId && state.page == action.payload.page) {
            return state;
        }

        const entries = state.promotionId == action.payload.promotionId ? [...state.entries, ...action.payload.entries] : [...action.payload.entries];

        return {
            ...state,
            entries: entries,
            grandPrizePoints: action.payload?.grandPrizePoints ?? 0,
            currentPoints: action.payload?.currentPoints ?? 0,
            promotionId: action.payload?.promotionId ?? 0,
            page: action.payload?.page ?? 0,
            totalRecords: action.payload?.totalRecords ?? 0,
        };
    } else {
        return state;
    }
};

const resetReducer = (state, action) => {
    return {
        ...defaultEntryState,
    };
};

const setLastEntryReducer = (state, action) => {
    return {
        ...state,
        last_entry: action.payload,
    };
};

const clearErrorsReducer = (state, action) => {
    return {
        ...state,
        error: '',
    };
};

export const entrySlice = createSlice({
    name: 'entry',
    initialState: defaultEntryState,
    reducers: {
        getEntries: getEntriesReducer,
        reset: resetReducer,
        setLastEntry: setLastEntryReducer,
        clearErrors: clearErrorsReducer,
    },
});

// ACTUAL ACTIONS
// a place to make the actions more complex if necessary
const getEntries = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading({ action: 'getEntries' }));
    const result = await apiClient.getEntries(payload);
    dispatch(entrySlice.actions.getEntries(result));
    dispatch(loadingSlice.actions.unsetLoading({ action: 'getEntries' }));
};

//actions that get exported to the views
export const entryActions = (dispatch) => {
    return {
        getEntries: (payload) => getEntries(dispatch, payload),
        reset: (payload) => dispatch(entrySlice.actions.reset(payload)),
        setLastEntry: (payload) => dispatch(entrySlice.actions.setLastEntry(payload)),
        clearErrors: (payload) => dispatch(entrySlice.actions.clearErrors()),
    };
};
